import React from 'react';

export interface CardProps {
  children: React.ReactNode;
  padding?: string;
  glow?: boolean;
  style?: React.CSSProperties;
  className?: string;
  onClick?: () => void;
}

export function Card({
  children,
  padding = 'var(--space-5)',
  glow = false,
  style,
  className,
  onClick,
}: CardProps) {
  return (
    <div
      onClick={onClick}
      className={className}
      style={{
        background: 'var(--bg-surface-raised)',
        border: '1px solid var(--border-subtle)',
        borderRadius: 'var(--radius-lg)',
        padding,
        boxShadow: glow
          ? 'var(--shadow-glow), var(--shadow-inset)'
          : 'var(--shadow-md), var(--shadow-inset)',
        boxSizing: 'border-box',
        ...style,
      }}
    >
      {children}
    </div>
  );
}
